import {
  SimpleShowLayout,
  TextField,
  NumberField,
  SelectField,
  Labeled,
  ReferenceField,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
} from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { StudyDurationUnitChoices } from "utils/choices";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { specialistRequests } from "api/specialistApi";

const BasicInfoSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <SimpleShowLayout>
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Наименование (БГ)">
            <TextField source="nameBg" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Наименование (EN)">
            <TextField source="nameEn" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Специалност">
            <ReferenceField
              source="specializationId"
              reference={specialistRequests.getSpecializationsSelect()}
            >
              <TextField source="nameBg" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Единица за продължителност">
            <SelectField
              source="studyDurationUnit"
              choices={StudyDurationUnitChoices}
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Продължителност">
            <NumberField source="studyDuration" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Валидност на сертификат (год.)">
            <TextField source="certValidityYears" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Labeled label="Сгради">
            <ReferenceArrayField
              source="buildingIds"
              reference={administrationRequests.getBuildingsSelect()}
            >
              <SingleFieldList linkType={false}>
                <ChipField
                  source="name"
                  size="small"
                />
              </SingleFieldList>
            </ReferenceArrayField>
          </Labeled>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};

export default BasicInfoSection;
